/* tslint:disable */
import {
  Company
} from '../index';

declare var Object: any;
export interface CertTemplateInterface {
  "name"?: string;
  "description"?: string;
  "companyId"?: number;
  "categories"?: Array<any>;
  "id"?: number;
  company?: Company;
}

export class CertTemplate implements CertTemplateInterface {
  "name": string;
  "description": string;
  "companyId": number;
  "categories": Array<any>;
  "id": number;
  company: Company;
  constructor(data?: CertTemplateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CertTemplate`.
   */
  public static getModelName() {
    return "CertTemplate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CertTemplate for dynamic purposes.
  **/
  public static factory(data: CertTemplateInterface): CertTemplate{
    return new CertTemplate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CertTemplate',
      plural: 'CertTemplates',
      path: 'CertTemplates',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "categories": {
          name: 'categories',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'companyId',
          keyTo: 'id'
        },
      }
    }
  }
}
